import {
  REPORT_CONSUMPTION_SHOTS_FAILURE,
  REPORT_CONSUMPTION_SHOTS_REQUEST,
  REPORT_CONSUMPTION_SHOTS_SUCCESS,
  REPORT_TRANSACTIONS_REQUEST,
  REPORT_TRANSACTIONS_SUCCESS,
  REPORT_TRANSACTIONS_FAILURE,
  REPORT_WHOLESALER_REPORT_REQUEST,
  REPORT_WHOLESALER_REPORT_SUCCESS,
  REPORT_WHOLESALER_REPORT_FAILURE,
  REPORT_TRANSACTIONS_SEARCH_REQUEST,
  REPORT_TRANSACTIONS_SEARCH_SUCCESS,
  REPORT_TRANSACTIONS_SEARCH_FAILURE,
  REPORT_CONSUMPTION_SHOTS_SEARCH_REQUEST,
  REPORT_CONSUMPTION_SHOTS_SEARCH_SUCCESS,
  REPORT_CONSUMPTION_SHOTS_SEARCH_FAILURE,
  REPORT_WHOLESALER_REPORT_SEARCH_REQUEST,
  REPORT_WHOLESALER_REPORT_SEARCH_SUCCESS,
  REPORT_WHOLESALER_REPORT_SEARCH_FAILURE,
  WHOLESALER_REPORT_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_DATE_SEARCH_SUCCESS,
  WHOLESALER_REPORT_DATE_SEARCH_FAILURE,
  REPORT_WHOLESALER_MONTH_REPORT_REQUEST,
  REPORT_WHOLESALER_MONTH_REPORT_SUCCESS,
  REPORT_WHOLESALER_MONTH_REPORT_FAILURE,
  REPORT_WHOLESALER_WEEK_REPORT_REQUEST,
  REPORT_WHOLESALER_WEEK_REPORT_SUCCESS,
  REPORT_WHOLESALER_WEEK_REPORT_FAILURE,
  WHOLESALER_REPORT_MONTH_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_MONTH_DATE_SEARCH_SUCCESS,
  WHOLESALER_REPORT_MONTH_DATE_SEARCH_FAILURE,
  WHOLESALER_REPORT_WEEK_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_WEEK_DATE_SEARCH_SUCCESS,
  WHOLESALER_REPORT_WEEK_DATE_SEARCH_FAILURE,
} from "./ReportTypes";

import { defaultStatus } from "../../screen/constant/defaultStatus";

const initialState = {
  viewAllConsumptionShots: { ...defaultStatus },
  viewAllTransactions: { ...defaultStatus },
  monthWholesalerReports: { ...defaultStatus },
  weekWholesalerReports: { ...defaultStatus },
  viewAllWholesalerReports: { ...defaultStatus },
  searchTransactions: { ...defaultStatus },
  searchConsumptionShots: { ...defaultStatus },
  searchWholesalerReports: { ...defaultStatus },
  weekDateSearchWholesalerReports: { ...defaultStatus },
  monthDateSearchWholesalerReports: { ...defaultStatus },
  dateSearchWholesalerReports: { ...defaultStatus },
};

export default function reportReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    //Consumption Shots
    case REPORT_CONSUMPTION_SHOTS_REQUEST:
      return {
        ...state,
        viewAllConsumptionShots: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_CONSUMPTION_SHOTS_SUCCESS:
      return {
        ...state,
        viewAllConsumptionShots: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_CONSUMPTION_SHOTS_FAILURE:
      return {
        ...state,
        viewAllConsumptionShots: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Transactions
    case REPORT_TRANSACTIONS_REQUEST:
      return {
        ...state,
        viewAllTransactions: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        viewAllTransactions: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_TRANSACTIONS_FAILURE:
      return {
        ...state,
        viewAllTransactions: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Month Report
    case REPORT_WHOLESALER_MONTH_REPORT_REQUEST:
      return {
        ...state,
        monthWholesalerReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_WHOLESALER_MONTH_REPORT_SUCCESS:
      return {
        ...state,
        monthWholesalerReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_WHOLESALER_MONTH_REPORT_FAILURE:
      return {
        ...state,
        monthWholesalerReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Week Report
    case REPORT_WHOLESALER_WEEK_REPORT_REQUEST:
      return {
        ...state,
        weekWholesalerReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_WHOLESALER_WEEK_REPORT_SUCCESS:
      return {
        ...state,
        weekWholesalerReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_WHOLESALER_WEEK_REPORT_FAILURE:
      return {
        ...state,
        weekWholesalerReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Day Report
    case REPORT_WHOLESALER_REPORT_REQUEST:
      return {
        ...state,
        viewAllWholesalerReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_WHOLESALER_REPORT_SUCCESS:
      return {
        ...state,
        viewAllWholesalerReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_WHOLESALER_REPORT_FAILURE:
      return {
        ...state,
        viewAllWholesalerReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Transactions Report Search
    case REPORT_TRANSACTIONS_SEARCH_REQUEST:
      return {
        ...state,
        searchTransactions: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_TRANSACTIONS_SEARCH_SUCCESS:
      return {
        ...state,
        searchTransactions: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_TRANSACTIONS_SEARCH_FAILURE:
      return {
        ...state,
        searchTransactions: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Consumption Shots Report Search
    case REPORT_CONSUMPTION_SHOTS_SEARCH_REQUEST:
      return {
        ...state,
        searchConsumptionShots: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_CONSUMPTION_SHOTS_SEARCH_SUCCESS:
      return {
        ...state,
        searchConsumptionShots: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_CONSUMPTION_SHOTS_SEARCH_FAILURE:
      return {
        ...state,
        searchConsumptionShots: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Month Date Search
    case WHOLESALER_REPORT_MONTH_DATE_SEARCH_REQUEST:
      return {
        ...state,
        monthDateSearchWholesalerReports: {
          ...defaultStatus,
          inProgress: true,
          error: false,
          success: false,
          ...payload,
        },
      };
    case WHOLESALER_REPORT_MONTH_DATE_SEARCH_SUCCESS:
      return {
        ...state,
        monthDateSearchWholesalerReports: {
          ...defaultStatus,
          inProgress: false,
          success: true,
          data: payload,
          error: false,
        },
      };
    case WHOLESALER_REPORT_MONTH_DATE_SEARCH_FAILURE:
      return {
        ...state,
        monthDateSearchWholesalerReports: {
          ...defaultStatus,
          inProgress: false,
          success: false,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Week Date Search
    case WHOLESALER_REPORT_WEEK_DATE_SEARCH_REQUEST:
      return {
        ...state,
        weekDateSearchWholesalerReports: {
          ...defaultStatus,
          inProgress: true,
          success: false,
          error: false,
          ...payload,
        },
      };
    case WHOLESALER_REPORT_WEEK_DATE_SEARCH_SUCCESS:
      return {
        ...state,
        weekDateSearchWholesalerReports: {
          ...defaultStatus,
          inProgress: false,
          success: true,
          error: false,
          data: payload,
        },
      };
    case WHOLESALER_REPORT_WEEK_DATE_SEARCH_FAILURE:
      return {
        ...state,
        weekDateSearchWholesalerReports: {
          ...defaultStatus,
          inProgress: false,
          success: false,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Day Date Search
    case WHOLESALER_REPORT_DATE_SEARCH_REQUEST:
      return {
        ...state,
        dateSearchWholesalerReports: {
          ...defaultStatus,
          inProgress: true,
          success: false,
          error: false,
          ...payload,
        },
      };
    case WHOLESALER_REPORT_DATE_SEARCH_SUCCESS:
      return {
        ...state,
        dateSearchWholesalerReports: {
          ...defaultStatus,
          inProgress: false,
          success: true,
          error: false,
          data: payload,
        },
      };
    case WHOLESALER_REPORT_DATE_SEARCH_FAILURE:
      return {
        ...state,
        dateSearchWholesalerReports: {
          ...defaultStatus,
          inProgress: false,
          success: true,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Report Search
    case REPORT_WHOLESALER_REPORT_SEARCH_REQUEST:
      return {
        ...state,
        searchWholesalerReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_WHOLESALER_REPORT_SEARCH_SUCCESS:
      return {
        ...state,
        searchWholesalerReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_WHOLESALER_REPORT_SEARCH_FAILURE:
      return {
        ...state,
        searchWholesalerReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    default:
      return state;
  }
}
